// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap */
import dist from "@turf/distance"
import { point } from "@turf/helpers"
import { Map, Record } from "immutable"
// @ts-expect-error: Flow to TS migration.
import memoize from "lru-memoize"

import Place from "./Place"
import LatLon from "../services/geo/latlon"
import { PLACE_TYPES } from "../consts/place"
import { normalizeLng } from "../services/map/coordinates"

export const MAX_RADIUS = 1000 /* in km */

const round = (num: number) => Math.round(num * 100) / 100

// hotfix, maybe do better
const getPlacesInRadiusMemoized = memoize(20)(
  (
    places: Map<string, Place>,
    lat: number,
    lng: number,
    radius: number,
    centralId?: string | null,
  ): Map<string, Place> => {
    const from = point([lng, lat])
    // FIXME: a method has been detected that possibly mutates the object, consider a more
    // functional approach (Ramda might help)

    // @ts-expect-error: Flow to TS migration.
    return places
      .filter(
        (item) =>
          // @ts-expect-error: Flow to TS migration.
          item.get("type") === PLACE_TYPES.CITY &&
          // @ts-expect-error: Flow to TS migration.
          dist(from, point([item.lng, item.lat])) <= radius,
      )
      .sort((a, b) => {
        if (centralId && a.get("id") === centralId) return -1
        if (centralId && b.get("id") === centralId) return 1
        const aDist = dist(from, point([a.lng, a.lat]))
        const bDist = dist(from, point([b.lng, b.lat]))
        return (a.rank + 1) * aDist - (b.rank + 1) * bDist
      })
  },
)

const RadiusRecord = Record({
  radius: 250,
  lat: 0,
  lng: 0,
  closeCity: null,
})

export default class Radius extends RadiusRecord {
  // @ts-expect-error: Flow to TS migration.
  radius: number

  // @ts-expect-error: Flow to TS migration.
  lat: number

  // @ts-expect-error: Flow to TS migration.
  lng: number

  closeCity: Place | null | undefined

  constructor(
    input: {
      radius?: number
      lat?: number | null | undefined
      lng?: number | null | undefined
      closeCity?: Place | null | undefined
    } = {},
  ) {
    const plain = { ...input } as const
    // @ts-expect-error: Flow to TS migration.
    if (plain.radius > MAX_RADIUS) {
      // @ts-expect-error: Flow to TS migration.
      plain.radius = MAX_RADIUS
    }
    super(plain)
  }

  getId() {
    if (this.closeCity) {
      // brno-cz-100km
      return `${this.closeCity.getId()}-${this.radius}km`
    }
    return `${round(this.lat)}-${round(normalizeLng(this.lng))}-${this.radius}km`
  }

  getSearchId() {
    return `${round(this.lat)}-${round(normalizeLng(this.lng))}-${this.radius}km`
  }

  getPlacesInRadius(places: Map<string, Place>): Map<string, Place> {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const centralId = this.closeCity && this.closeCity.get("id")
    return getPlacesInRadiusMemoized(places, this.lat, this.lng, this.radius, centralId)
  }

  isPlaceInRadius(place: Place): boolean {
    return (
      [place.lat, place.lng, this.lat, this.lng].every(Boolean) &&
      // @ts-expect-error: Flow to TS migration.
      LatLon(place.lat, place.lng).distanceTo(LatLon(this.lat, this.lng)) <= this.radius
    )
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering, @typescript-eslint/no-explicit-any
  static fromPlainJS(plain: any) {
    return new Radius({
      ...plain,
      closeCity: plain.closeCity ? Place.fromPlainJS(plain.closeCity) : null,
    })
  }
}
